import React from 'react'
import { componentesOperaciones as componentes } from './TestData/ComponentesFormacionOperacion';

import {makeStyles, Grid } from '@material-ui/core';
import { VisorEnlacesCategoria } from './VisorEnlacesCategoria';

export const FormacionOperaciones = (props:any) => {
    const useStyles = makeStyles(theme => ({
    linea: {
        padding: theme.spacing(1)
    },
    mainContainer:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-around',
        alignContent: 'stretch',
        alignItems: 'flex-start', 
        padding: '1%',
    },
    }));
    const classes = useStyles();
    let test = props?.test ?? false;
    return  <div className = {classes.mainContainer}>
            <Grid container spacing={2} style={{ padding: "6px 0px" }}>
                <Grid item xs={12} md={12} lg={4}>
                    <VisorEnlacesCategoria IdComponente={"links-sbfo-nuevasincorporaciones"} data={test?componentes[0].Data:""} titulo={"Nuevas incorporaciones"}></VisorEnlacesCategoria>
                    <div style={{ padding: "10px 0px" }} ></div>
                    <VisorEnlacesCategoria IdComponente={"links-sbfo-noticias"} data={test?componentes[1].Data:""} titulo={"Noticias"}></VisorEnlacesCategoria>
                </Grid> 
                <Grid item xs={12} md={6} lg={4}>
                    <VisorEnlacesCategoria IdComponente={"links-sbfo-tecnicasyhabilidades"} data={test?componentes[2].Data:""} titulo={"Técnicas y habilidades"}></VisorEnlacesCategoria>
                    <div style={{ padding: "10px 0px" }} ></div>
                    <VisorEnlacesCategoria IdComponente={"links-sbfo-bancoderecursos"} data={test?componentes[3].Data:""} titulo={"Banco de recursos"}></VisorEnlacesCategoria>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <VisorEnlacesCategoria IdComponente={"links-sbfo-gestiondeprocedimientos"} data={test?componentes[4].Data:""} titulo={"Gestión de procedimientos"}></VisorEnlacesCategoria>
                </Grid>
            </Grid>
        </div>
}
